// removed by extract-text-webpack-plugin
module.exports = {"root":"Section--root--u3","title":"Section--title--9X","riseTitle":"Section--riseTitle--3p","list":"Section--list--jb","set":"Section--set--1g","setBig":"Section--setBig--2G Section--set--1g"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Section/styles.styl
// module id = 837
// module chunks = 0